import React, { useState} from 'react';
import './HeaderTwo.css';
import { Link } from 'react-router-dom';
import BixianLogo from '../assets/logos/BixianLogo.png'

export default function HeaderTwo() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleServicesMenu = () => {
    setIsServicesOpen(!isServicesOpen);
  };

//   for scrolled header
// const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrolled = window.scrollY > 5;
//       setIsScrolled(scrolled);
//     };

//     window.addEventListener('scroll', handleScroll);

//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);


  return (
      <div className='headerTwo'>
        <div className='container'>
        <Link to='/'><img src={BixianLogo} className='logo' alt='logo'/></Link>
        <ul className='navItems'>
            <li className='navItem'>
            <Link to="/">Home</Link>
            </li>
            <li className='navItem'>
            <Link to='/services'>Services</Link>
            <button className='services-dropdown' onClick={toggleServicesMenu}>
                {isServicesOpen ? '▴' : '▾'}
            </button>
            </li>
            <li className='navItem'>
            <Link to="/blog">Blogs</Link>
            </li>
            <li className='navItem'>
            <Link to="/about">About Us</Link>
            </li>
            <li className='navItem'>
            <Link to="/contact">Contact Us</Link>
            </li>
            <li className='navItem'>
            <Link to="/careers">Careers</Link>
            </li>
            {/* ... other navigation items */}
        </ul>
        {/* Separate container for submenu, positioned absolutely */}
        {isServicesOpen && (
            <ul className='services-submenu'> {/*style={{ position: 'absolute' }}*/ /*this was inside this ul className='services-submenu'*/}
            <li className='navItem'>
                <Link to='/services/socialmediamarketing'>Social Media Marketing</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/payperclickads'>Pay-Per-Click Ads</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/websitedesigning'>Website Designing</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/whatsappmarketing'>WhatsApp Marketing</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/bulksms'>Bulk SMS</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/videoads'>Video Ads</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/searchengineoptimization'>Search Engine Optimization</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/emailmarketing'>Email Marketing</Link>
            </li>
            <li className='navItem'>
                <Link to='/services/influencermarketing'>Influencer Marketing</Link>
            </li>
            {/* ... other submenu items */}
            </ul>
        )}
        </div>
    </div>
  );
}
